@if (mode === 'normal') {
    <div class="card border-0 shadow-sm pt-0 mb-4">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div class="fs-5 fw-medium">
                Notes @if (required) { <span class="text-danger">*</span> }
            </div>
            <div class="d-flex align-items-center gap-2">
                <dx-button
                    icon="export"
                    hint="Export notes"
                    stylingMode="text"
                    (onClick)="exportNotes()"
                ></dx-button>
                @if (canCreate) {
                    <dx-button
                        text="Create note"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="openCreatePopup()"
                    ></dx-button>
                }
            </div>
        </div>
        <div class="card-body">
            <dx-load-panel [visible]="isLoading" [showPane]="false" [position]="{ of: '.card-body' }"></dx-load-panel>

            @if (!isLoading) {
                @for (note of notes; track note; let last = $last) {
                    <div class="border rounded p-3 note-bg" [class.mb-3]="!last">
                        <div class="text-muted small mb-2 d-flex align-items-center gap-1">
                            <i class="dx-icon-clock"></i>
                            <span class="me-1">{{ note.lastModified | date: dateTimeFormat }}</span>
                            <i class="dx-icon-user"></i>
                            <span>{{ note.lastModifiedBy?.name }}</span>
                            @if (note.isInternal) {
                                <i class="dx-icon-lock"></i>
                                <span>Internal Team</span>
                            }
                        </div>
                        <div class="mb-2 text-wrap" style="white-space: pre-wrap;">{{ note.body }}</div>
                        @if (note.attachments?.length) {
                            <div class="d-flex flex-column gap-1 mt-2">
                                @for (file of note.attachments; track file) {
                                    <div class="d-flex align-items-center gap-2">
                                        <a href="#" [appSignedLink]="file.fileUrl" class="text-decoration-none">
                                            <i class="dx-icon-attach"></i> {{ file.fileName }}
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                @if (!notes?.length) {
                    <div class="text-center text-muted">No notes found.</div>
                }
            }
        </div>
    </div>
}

<dx-popup
    [(visible)]="isPopupVisible"
    title="Create Note"
    height="auto"
    [width]="600"
    [wrapperAttr]="{'class':'form-popup'}"
    (onHidden)="onPopupHidden()"
    [showCloseButton]="true"
>
    <dx-validation-group #validationGroup>
        <div class="d-flex flex-column gap-3">
            <div>
                <label class="form-label">Note Details</label>
                <dx-text-area
                    [(value)]="newNoteBody"
                    stylingMode="filled"
                    [height]="300"
                    placeholder="Enter note details..."
                    [maxLength]="3000"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Note details are required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </div>
            <div>
                <dx-check-box text="Visible to Internal Team only" [(value)]="isInternal" [visible]="canCreateInternal"></dx-check-box>
            </div>
            <div>
                <label class="form-label">Attachments (Optional)</label>
                <dx-file-uploader
                    selectButtonText="Upload Files"
                    labelText="or Drag and Drop files here"
                    uploadMode="useForm"
                    [(value)]="newNoteFiles"
                    [multiple]="true"
                    [maxFileSize]="maxFileSize"
                    (onValueChanged)="onFilesUploadChanged($event)"
                ></dx-file-uploader>
            </div>
        </div>
    </dx-validation-group>

    <dxi-popup-toolbar-item toolbar="bottom" location="center">
        <div class="d-flex align-items-center justify-content-end gap-3">
            <dx-button
                text="Submit"
                stylingMode="contained"
                type="default"
                (onClick)="saveNote()"
            ></dx-button>
            <dx-button
                text="Cancel"
                stylingMode="contained"
                type="normal"
                (onClick)="cancelNote()"
            ></dx-button>
        </div>
    </dxi-popup-toolbar-item>
</dx-popup>
